
// Default referral templates by campaign
const campaignTemplates = {
  'summer-promo': {
    id: 'summer-template',
    name: 'Summer Promotion',
    template: 'Join me for our summer special offer! Sign up using my link: {referralLink}',
    subject: 'Summer Special Offer Inside!'
  },
  'holiday-special': {
    id: 'holiday-template',
    name: 'Holiday Special',
    template: 'Here\'s a special holiday gift - use my referral link for a bonus when you sign up: {referralLink}',
    subject: 'Holiday Gift For You!'
  },
  'default': {
    id: 'default-template',
    name: 'Default Template',
    template: 'I thought you might be interested in this. Check it out using my referral link: {referralLink}',
    subject: 'Check out this referral!'
  }
};

// Mock data for URLs and templates
let referralURLs = [
  {
    id: 'url-1',
    name: 'Default URL',
    url: 'https://example.com/refer',
    isDefault: true,
    createdAt: new Date('2023-01-01').toISOString()
  },
  {
    id: 'url-2',
    name: 'Summer Campaign',
    url: 'https://example.com/summer',
    isDefault: false,
    createdAt: new Date('2023-05-15').toISOString()
  }
];

let referralTemplates = [
  {
    id: 'template-1',
    name: 'Default Email',
    subject: 'Check out this referral!',
    body: 'I thought you might be interested in this. Check it out using my referral link: {referralLink}',
    type: 'email',
    isDefault: true,
    createdAt: new Date('2023-01-01').toISOString(),
    updatedAt: new Date('2023-01-01').toISOString()
  },
  {
    id: 'template-2',
    name: 'Summer Promotion',
    subject: 'Summer Special Offer Inside!',
    body: 'Join me for our summer special offer! Sign up using my link: {referralLink}',
    type: 'email',
    isDefault: false,
    createdAt: new Date('2023-05-15').toISOString(),
    updatedAt: new Date('2023-05-15').toISOString()
  }
];

// Get the default template for a specific campaign
export const getDefaultTemplateForCampaign = (campaignId: string) => {
  return campaignTemplates[campaignId as keyof typeof campaignTemplates] || campaignTemplates.default;
};

// Referral rewards configuration
export const referralRewards = {
  signupBonus: 50,
  referralBonus: 100,
  tieredBonuses: {
    5: 200,  // 5 successful referrals: 200 bonus points
    10: 500, // 10 successful referrals: 500 bonus points
    25: 1500 // 25 successful referrals: 1500 bonus points
  }
};

// Referral settings
export const referralSettings = {
  expirationDays: 30, // Referral links expire after 30 days
  doublePointsPeriod: {
    active: true,
    startDate: new Date('2023-01-01'),
    endDate: new Date('2023-12-31'),
    multiplier: 2
  },
  showLeaderboards: true,
  allowSocialSharing: true
};

// Add the missing functions
export const getReferralURLs = () => {
  return [...referralURLs];
};

export const getReferralTemplates = () => {
  return [...referralTemplates];
};

export const saveReferralURL = (url: any) => {
  if (url.id) {
    const index = referralURLs.findIndex(u => u.id === url.id);
    if (index !== -1) {
      referralURLs[index] = { ...url };
    }
  } else {
    url.id = `url-${Date.now()}`;
    url.createdAt = new Date().toISOString();
    referralURLs.push(url);
  }
  return url;
};

export const deleteReferralURL = (urlId: string) => {
  referralURLs = referralURLs.filter(u => u.id !== urlId);
  return true;
};

export const saveReferralTemplate = (template: any) => {
  if (template.id) {
    const index = referralTemplates.findIndex(t => t.id === template.id);
    if (index !== -1) {
      referralTemplates[index] = { 
        ...template, 
        updatedAt: new Date().toISOString() 
      };
    }
  } else {
    template.id = `template-${Date.now()}`;
    template.createdAt = new Date().toISOString();
    template.updatedAt = new Date().toISOString();
    referralTemplates.push(template);
  }
  return template;
};

export const deleteReferralTemplate = (templateId: string) => {
  referralTemplates = referralTemplates.filter(t => t.id !== templateId);
  return true;
};

export const getReferralTemplatesByCampaign = (campaignId: string) => {
  // In a real app, this would filter templates based on campaign
  return referralTemplates;
};

export const savePointsValue = (pointsValue: number) => {
  localStorage.setItem('pointsValue', pointsValue.toString());
  return true;
};
